import React from 'react'
import { graphql } from 'gatsby'
import { Box, Heading, Text } from 'rebass/styled-components'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Container from '../components/container'

const CookiesPage = ({ data }) => (
  <Layout hideMenuToggle showSecondaryLogo>
    <SEO
      title="Nakládání s cookies"
      description="Nakládání s cookies"
    />

    <Box sx={{ py: 6 }}>
      <Container>
        <Heading as="h1" sx={{ mb: 5, color: 'primary', fontSize: 6 }}>
          Nakládání s cookies
        </Heading>

        <Text
          variant="body"
          dangerouslySetInnerHTML={{ __html: data.cookies.html }}
        />
      </Container>
    </Box>
  </Layout>
)

export default CookiesPage

export const pageQuery = graphql`
  {
    cookies: markdownRemark(frontmatter: { slug: { eq: "cookies" } }) {
      frontmatter {
        title
      }
      html
    }
  }
`
